const prefix = 'TALLY:'

export const SET_FINANCIALS_FOR_SYNC = prefix + 'SET_FINANCIALS_FOR_SYNC'
export const SYNC_SUCCESS = prefix + 'SYNC_SUCCESS'
export const SET_PAST_FINANCIALS = prefix + "SET_PAST_FINANCIALS"